/*
	tcr.location.js - everything re locations
    - initialises a Hash of Country to Delivery Zone mappings

    NOTE: Remember to add Shipping country to Shopify as well

    Changes:
    	2 June 2014 - Added Greece & Turkey
        13 July 2014 - Added Indonesia & Kenya
        15 July 2014 - Added TCR Zones. Use instead of FCR
        4 Sept - added Korea
        29 Sept - Added Serbia
        24 October - Added Brunei
        12 Dec - added supprt for preferences and cookies
        27 Jan - Added Namibia. Added NZ to top
        5 Feb - moved lots to tcr.preferences
        1 Nov - v1.1 - added UK gneric
        22 Jan 2016 1.2 - Made getCountryZone public
        19 Dec 2016 - Updates for SSL
        7 Feb 2017 - Loaded Flag Icons into assets and used
        26 June 2017 - Added Zone 1 and 2 Tracked options
        17 Feb 2018 - Added alt to images
        8 March 2018 - 1.4 - Added new countries - Bosnia
*/

TCR.location = (function() {

  LTK.logHide.push( 'TCR.location' );	// Hide all these log messages

  // EXTERNAL functions
  function log(text) { TCR.log(text); };
  function info(text) { TCR.info(text); };
  function warning(text) { TCR.warning(text); };
  function error(text) { TCR.error(text); throw(text); };
  function message(text) { TCR.message(text); };
  function closeMessage() { TCR.closeMessage(); };
  function isBlank( obj ) { return LTK.isBlank( obj ); };
  function notBlank( obj ) { return LTK.notBlank( obj ); };
  function isJSONString( s ) { return LTK.isJSONString( s ); };

  var mod = "TCR.location.";
  var fn = mod + "() ";
  log( mod + "JS..." );

  
  // Don't use '&' - cart attributes doesn't handle it

  var aus_nz_zone = "Australia and New Zealand";
  var cent_am_zone = "Central America";
  var euro_zone = "Europe";
  var mid_east_zone = "Middle East";
  var asia_zone = "Asia";
  var africa_zone = "Africa";
  var south_am_zone = "South America";
  var uk_zone = "United Kingdom";
  var usa_can_zone = "USA and Canada";

  //	Maps a Courier zone to a World Country Zone.  A Country zone can be in multiple Courier Zones.
  //	A Courier Zone can link to multiple county Zones
  //	The Courier Zone names must match Delivery Zone in MS-Access and Variants

  var COURIER_MAP = {
    "Courier UK": uk_zone,
    "RM United Kingdom": uk_zone,
    "RM Europe": euro_zone,
    "RM World Zone 1": mid_east_zone + ":" + africa_zone + ":" + asia_zone + ":" +
    usa_can_zone + ":" + cent_am_zone + ":" + south_am_zone,
    "RM World Zone 2": aus_nz_zone,
    "Royal Mail UK": uk_zone,
    "UK": uk_zone,
    
    "Royal Mail Europe": euro_zone,

    "Royal Mail World Zone 1 - Tracked": mid_east_zone + ":" + africa_zone + ":" + asia_zone + ":" +
    usa_can_zone + ":" + cent_am_zone + ":" + south_am_zone,
    "Royal Mail World Zone 1": mid_east_zone + ":" + africa_zone + ":" + asia_zone + ":" +
    usa_can_zone + ":" + cent_am_zone + ":" + south_am_zone,
    
    "Royal Mail World Zone 2 - Tracked": aus_nz_zone,
    "Royal Mail World Zone 2": aus_nz_zone,

    "Royal Mail USA-Canada": usa_can_zone,
    "FCR Europe": euro_zone,
    "FCR USA and Canada": usa_can_zone,
    "TCR Europe": euro_zone,
    "TCR USA and Canada": usa_can_zone
  };

  //	Keep countries in alphabetical order
  var COUNTRY_MAP = {
    "United Kingdom": { zone: uk_zone, code: "gb" },
    "New Zealand": 	{ zone: aus_nz_zone, code: "nz" },
    Armenia: 			{ zone: euro_zone, code: "am" },
    Australia: 		{ zone: aus_nz_zone, code: "" },
    Austria: 			{ zone: euro_zone, code: "" },
    Belgium: 			{ zone: euro_zone, code: "" },
    "Bosnia & Herzegovina": { zone: euro_zone, code: "" },
    Brazil: 			{ zone: south_am_zone, code: "" },
    Brunei: 			{ zone: mid_east_zone, code: "" },
    Bulgaria: 		{ zone: euro_zone, code: "" },
    Canada: 			{ zone: usa_can_zone, code: "" },
    China:  			{ zone: asia_zone, code: "" },
    Colombia: 		{ zone: cent_am_zone, code: "" },
    "Costa Rica": 	{ zone: cent_am_zone, code: "" },
    Cyprus: 			{ zone: euro_zone, code: "" },
    "Czech Republic": { zone: euro_zone, code: "" },
    Denmark: 			{ zone: euro_zone, code: "" },
    Estonia: 			{ zone: euro_zone, code: "" },
    Finland: 			{ zone: euro_zone, code: "" },
    France: 			{ zone: euro_zone, code: "fr" },
    Germany: 			{ zone: euro_zone, code: "" },
    Greece: 			{ zone: euro_zone, code: "" },
    "Hong-Kong": 		{ zone: asia_zone, code: "" },
    India:  			{ zone: asia_zone, code: "" },
    Indonesia:  		{ zone: asia_zone, code: "" },
    Ireland: 			{ zone: euro_zone, code: "" },
    "Isle of Man": 	{ zone: uk_zone, code: "" },
    Israel: 			{ zone: euro_zone, code: "" },
    Italy: 			{ zone: euro_zone, code: "it" },
    Japan:  			{ zone: asia_zone, code: "" },
    Jordan: 			{ zone: euro_zone, code: "" },
    Kenya:  			{ zone: africa_zone, code: "" },
    "Korea, Republic of":  { zone: asia_zone, code: "" },
    Lithuania: 		{ zone: euro_zone, code: "" },
    Luxembourg: 		{ zone: euro_zone, code: "" },
    Malaysia:  		{ zone: asia_zone, code: "" },
    Malta: 			{ zone: euro_zone, code: "" },
    Mexico: 			{ zone: south_am_zone, code: "" },
    "Moldova, Republic of": 	{ zone: euro_zone, code: "" },
    Monaco: 			{ zone: euro_zone, code: "" },
    Namibia:  			{ zone: africa_zone, code: "" },
    Netherlands: 		{ zone: euro_zone, code: "" },
    Norway: 			{ zone: euro_zone, code: "" },
    "Northern Ireland": { zone: uk_zone, code: "" },
    Panama: 			{ zone: cent_am_zone, code: "" },
    Poland: 			{ zone: euro_zone, code: "" },
    Portugal: 		{ zone: euro_zone, code: "" },
    Romania: 			{ zone: euro_zone, code: "" },
    Russia: 			{ zone: euro_zone, code: "" },
    Serbia: 			{ zone: euro_zone, code: "" },
    Singapore:  		{ zone: asia_zone, code: "" },
    Slovakia: 		{ zone: euro_zone, code: "" },
    Slovenia: 		{ zone: euro_zone, code: "" },
    "South Africa": 	{ zone: africa_zone, code: "" },
    Spain: 			{ zone: euro_zone, code: "" },
    Sweden: 			{ zone: euro_zone, code: "" },
    Switzerland: 		{ zone: euro_zone, code: "" },
    Taiwan:  			{ zone: asia_zone, code: "" },
    Thailand:  		{ zone: asia_zone, code: "" },
    Turkey: 			{ zone: euro_zone, code: "" },
    Uganda: 			{ zone: africa_zone, code: "" },
    Ukraine: 			{ zone: euro_zone, code: "" },
    "United Arab Emirates": { zone: mid_east_zone, code: "" },
    "United States": 	{ zone: usa_can_zone, code: "" },
    Vietnam:  		{ zone: asia_zone, code: "" }
  };

  function getCountryZone( country ) {
    //log("getCountryZone(country): " + country);
    if ( isBlank( COUNTRY_MAP[ country ] ) ) return "";
    
    return COUNTRY_MAP[ country ].zone;
  };
  function getCountryCode( country ) {
    if ( isBlank( COUNTRY_MAP[ country ] ) ) return "";

    return COUNTRY_MAP[ country ].code;
  };

  //	Parse a JSON location string and return the object if all seems OK
  
  function parseLocation( json_location ) {
    if( ! isJSONString( json_location ) ) return {};
    
    var location = $.parseJSON( json_location );
    if( isBlank( location ) ) return {};
    if( isBlank( location.country ) ) return {};
    if( isBlank( COUNTRY_MAP [ location.country ] ) ) return {};
    return location;
  };
  

  // Return the <img> element for a countries flag
  function getFlagImage( country ) {
    var html = "";
    var flag_image="";

    switch ( country ) {
      case 'Bosnia & Herzegovina':
        flag_image = 'Bosnia-and-Herzegovina-Flag-icon.png'
        break;

      case 'Estonia':
        flag_image = country + '-icon.png'
        break;

      case 'Moldova, Republic of':
        flag_image = 'Moldova-Flag-icon.png'
        break;

      case 'Northern Ireland':
        flag_image = country.replace(' ', '-') + '-icon.png'
        break;

      case 'Korea, Republic of':
        flag_image = 'Korea-Flag-icon.png'
        break;

      case 'United Arab Emirates':
        flag_image = country.replace(/ /g, '-') + '-icon.png'
        break;

      case 'United Kingdom':
        flag_image = country.replace(/ /g, '-') + '-flag-icon.png'
        break;
      default:
        flag_image = country.replace(/ /g, '-') + '-Flag-icon.png'
    }

    // //cdn.shopify.com/s/files/1/0181/3537/t/29/assets
    
    //html = '<img class="icon" src="https://icons.iconarchive.com/icons/custom-icon-design/all-country-flag/48/' +
      //flag_image + '"/>'
    html = '<img class="icon" src="//cdn.shopify.com/s/files/1/0181/3537/t/33/assets/' +
      flag_image + '" alt="' + country + ' flag" />'

    return html;
  }

  /*
	geo2tcr - convert location from GEO service to TCR location
*/
  function geo2tcr( geo_location ) {
    var fn = mod + "geo2tcr() ...OK";
    var tcr_location = {};

    if ( isBlank( geo_location.country ) ) {
      // Got a geo_location but no country - set to default
      tcr_location = DEFAULT_LOCATION;
    } else {
      tcr_location.city =			geo_location.city;
      tcr_location.country =		geo_location.country;
      tcr_location.country_code =	geo_location.country_code;
    }

    tcr_location.country_zone =	getCountryZone( tcr_location.country );
    log( fn );
    return tcr_location;
  };


  //	Build a Location object given a country string. Return object
  //	Country may be blank and if so return empty object
  
  function buildByCountry( country ) {
    var fn = mod + "buildByCountry() ";
    //log( fn + "...Country: " + country );

    var location = {};
    if ( typeof( country ) === "undefined" || country == "" ) return location;
    
    // Set the zone
    var zone = getCountryZone( country );

    if( isBlank( zone ) ) {
      warning("Could not set Zone for country [" + country + "]" );
      return location;
    }
    location.country = country;
    location.country_zone = zone;

    // Set list of couriers
    location.couriers = [];
    jQuery.each(COURIER_MAP, function( courier, zones ) {
      if( zones.indexOf( location.country_zone ) > -1 ) {
        location.couriers.push( courier );
      }
    });

    //log( fn + "Location: " + JSON.stringify( location ));
    return location;
  }

  
  $(document).ready(function() {
    var fn = mod + "doc() ";
    //log( fn + "DOM ready" );
  });

  // location - MAIN
  function main() {
    var fn = mod + "main() ";

    log( fn + "...OK");
  }

  //main();

  log( mod + "JS...OK")
  //	Public methods

  return {
    buildByCountry: buildByCountry,
    country_map: COUNTRY_MAP,
    getCountryZone: getCountryZone,
    getFlagImage: getFlagImage,
    parse: parseLocation
  };

})();	// End of TCR.location Module - IFFE pattern
